import {sequenceS} from 'fp-ts/lib/Apply';
import * as NEA from 'fp-ts/lib/NonEmptyArray';
import * as O from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';
import {createSelector} from 'reselect';
import {ReducerState} from 'rootReducer';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {prop} from 'Shared/utilities/prop';

const agentNumbersSelector = createSelector(
  (state: ReducerState) => state.user.profile.currentAgentNumbers,
  agentNumbers => pipe(agentNumbers, NEA.fromArray, O.map(NEA.map(prop('value'))))
);

const isNewYorkSelector = createSelector(
  (state: ReducerState) => state.user.profile.currentAgentNumbers,
  agentNumbers => pipe(NEA.fromArray(agentNumbers), O.map(NEA.head), O.map(prop('isNewYork')))
);

const encryptedIdentifierSelector = createSelector(
  (state: ReducerState) => state.user.profile.selectedAgency,
  selectedAgency => pipe(selectedAgency, O.map(prop('encryptedIdentifier')))
);

const agencyFilterSelector = createSelector(
  agentNumbersSelector,
  isNewYorkSelector,
  encryptedIdentifierSelector,
  (agentNumbers, isNewYork, encryptedIdentifier): O.Option<AgencyFilters> =>
    sequenceS(O.option)({
      agentNumbers,
      isNewYork,
      encryptedIdentifier,
    })
);

export default agencyFilterSelector;
